import { render } from "./tubeFLModal.vue?vue&type=template&id=10bbd438&scoped=true"
import script from "./tubeFLModal.vue?vue&type=script&lang=js"
export * from "./tubeFLModal.vue?vue&type=script&lang=js"

import "./tubeFLModal.vue?vue&type=style&index=0&id=10bbd438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bbd438"]])

export default __exports__